export default "__VITE_ASSET__C0gDH1p6__"